import React from 'react';

const defaultViewModelService = null;
export default React.createContext(defaultViewModelService);
